import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from "connected-react-router";
import Router from 'admin/routes/router';
import LiveStreamList from 'admin/views/live-stream/list'
import { changeContentOrders, getContentTipHistoryById, getPinnedCountStatistics } from 'admin//api/AuthApi';
import { contentMetaInfoSelector, screenWidthSelector, siteInfoSelector } from 'admin/state/modules/common/selectors';
import {
   initDataSelector,
   isFetchingSelector,
   recordedStreamsSelector,
   isFetchingRecordFilterSelector,
   isEmptyByFilterRecordSelector,
   isNewFetchingRecordsSelector,
   ivsSelector,
   deleteRecordButtonDisabledSelector,
   isEmptyByRecordSelector,
   isFetchingRecordSelector,
   warningModalSelector,
   isInitedSelector,
   filtersInsideModalSelector,
} from 'admin/state/modules/livestream/selectors';
import {
   fetchIndexOperation,
   recoredStreamsNextPageOperation,
   deleteRecordStreamOperation,
   fetchRecordStreamsOperation,
   pinRecordedStreamOperations,
} from 'admin/state/modules/livestream/operations';
import {
   createOrUpdateRecordStream, reorderRecordedStreams,
   setWarningModal,
   updateFiltersInsideModalAction,
   updateLivestreamInitedStateAction,
} from 'admin/state/modules/livestream/actions';
import PageLoader from 'common/components/modules/page-loading';

import {
   resourcesSelector,
   countesStateSelector,
   mediaDownloadButtonSelector,
} from 'admin/state/modules/resources/selectors';

import { fetchMediaCountsStateOperation, downloadMediaOperation } from 'admin/state/modules/resources/operations';

import QueryParams from 'admin/utils/QueryParams';
import { isEmpty } from 'lodash'
import intercomMoreInfo, {
   REQUEST_LIVESTREAM_ACCESS,
} from 'admin/utils/IntercomMoreInfo';
import DeleteModal from 'admin/views/manage-resource/delete-modal';
import Modal from 'common/components/modules/modal';
import TippersModal from 'admin/views/tips/tippers-details-modal'
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import { contentMetaInfo } from 'admin/state/modules/common/actions';
import { checkAndUnlockDemoPublicSiteOperation, loginAsOperation } from 'admin/state/modules/common/operations';
import toast from 'common/utils/toast';
import { history } from 'admin/state/store';
import { generateUriSegment } from 'common/utils/mediaRouteHelper';

class LiveStreamIndexContainer extends Component {
   static propTypes = {
      screenWidth: PropTypes.number,
      goTo: PropTypes.func,
      initData: PropTypes.object,
      fetchIndex: PropTypes.func,
      recordedStreams: PropTypes.object,
      resources: PropTypes.object,
      isFetching: PropTypes.bool,
      isFetchingRecordFilter: PropTypes.bool,
      isEmptyByFilterRecord: PropTypes.bool,
      isNewFetchingRecords: PropTypes.bool,
      recoredStreamsNextPage: PropTypes.func,
      deleteRecordStream: PropTypes.func,
      ivs: PropTypes.object,
      deleteRecordButtonDisabled: PropTypes.bool,
      isEmptyByRecord: PropTypes.bool,
      fetchRecordStreams: PropTypes.func,
      updateRecordStream: PropTypes.func,
      isFetchingRecord: PropTypes.bool,
      siteInfo: PropTypes.object,
      fetchCountsState: PropTypes.func,
      downloadFile: PropTypes.func,
      countesState: PropTypes.object,
      mediaDownloadButton: PropTypes.bool,
      reorderRecordedStreams: PropTypes.func,
      contentMetaInfo: PropTypes.object,
      updateContentMetaInfo: PropTypes.func,
      loginAs: PropTypes.func,
      pinRecordedStream: PropTypes.func,
      isInsideModal: PropTypes.bool,
      showNewStyles: PropTypes.bool,
      selections: PropTypes.array,
      onSelectThisVideo: PropTypes.func,
      contentType: PropTypes.string,
      prevetInsideModalDiscard: PropTypes.func,
      bundleId: PropTypes.any,
      setWarningModal: PropTypes.func,
      warningModal: PropTypes.object,
      hideScheduledContents: PropTypes.bool,
      hideUnpublishedContents: PropTypes.bool,
      isInited: PropTypes.bool,
      updateLivestreamInitedState: PropTypes.bool,
      updateFiltersInsideModal: PropTypes.func,
      filtersInsideModal: PropTypes.object,
      checkAndUnlockDemoPublicSite: PropTypes.func,
      preventAutoSelect: PropTypes.bool,
      isCastMemberProfilePage: PropTypes.bool,
      castMemberId: PropTypes.number,
      showOnlyList: PropTypes.bool,
      hiddenIds: PropTypes.string,
   }

   constructor(props) {
      super(props)
      this.state = {
         emptyFilters: true,
         openDeletModal: false,
         isReorderMode: history.location.pathname === '/livestream/reorder',
         confirmModal: {
            isOpen: false,
         },
         reorderedData: {
            newData: [],
            newIndex: null,
         },
         pinnedCount: {},
      }
      this.deleteVideoId = null;
      this.filter = {
         page: 1,
         count: 20,
         // status: this.props.isInsideModal ? 'published,unpublished' : '',
         hideScheduledContents: !!this.props?.hideScheduledContents,
         hideUnpublishedContents: !!this.props?.hideUnpublishedContents,
         insideModal: !!this.props.isInsideModal ? 1 : 0,
         status: history.location.pathname === '/livestream/reorder' ? 'published' : '',
         hiddenIds: this.props?.hiddenIds,
      };
   }

   componentDidMount() {
      const { fetchIndex, fetchCountsState, isInited, isInsideModal, filtersInsideModal, isCastMemberProfilePage, castMemberId } = this.props
      let params = QueryParams.getFilters();
      if('models' in params){
         params.casts = params.models;
         delete params.models
      }
      this.filter = {
         ...this.filter,
         ...params,
         ...filtersInsideModal,
      }

      if(isCastMemberProfilePage) {
         this.filter = {
            ...this.filter,
            casts: String(castMemberId),
         }
      }

      const param = this.generateQuery()
      let emptyFilterParams = isEmpty(params)

      if(isInsideModal && !!Object.keys(filtersInsideModal)?.length) emptyFilterParams = false

      this.setState({ emptyFilters: emptyFilterParams })

      if(this.state.isReorderMode || !isInited || isCastMemberProfilePage) {
         fetchIndex(param, true, isInsideModal, this.state.isReorderMode, isCastMemberProfilePage)
         if(!isInsideModal) {
            fetchCountsState(param);
         }
      }

      if(!isInsideModal) {
         getPinnedCountStatistics('videos', ['video-type=recorded-streams'])
            .then(resp => {
               this.setState({
                  pinnedCount: {
                     ...resp?.data,
                  },
               })
            })
            .catch(err => console.log(err))
      }

      window.addEventListener('scroll', this.handleScroll);
   }

   componentDidUpdate(){
      const { isFetching, prevetInsideModalDiscard, isInsideModal } = this.props

      if(!!prevetInsideModalDiscard && isInsideModal) {
         prevetInsideModalDiscard(isFetching)
      }
   }


   componentWillUnmount() {
      const { updateLivestreamInitedState, isInsideModal, contentType } = this.props
      if(isInsideModal && contentType !== 'related_content') {
         updateLivestreamInitedState(false)
      }
      this.onCloseWarningModal();

      window.removeEventListener('scroll', this.handleScroll);
   }

   handleScroll = (e) => {
      const { isFetching } = this.props
      if(isFetching) return
      const { scrollHeight, clientHeight, scrollTop } = document.documentElement;
      const { isAdded } = this.state;
      let diff = (scrollHeight - scrollTop) - clientHeight
      if(diff < 100 && !isAdded) {
         this.nextPage()
      }
   }

   nextPage = async () => {
      const {
         recoredStreamsNextPage, isNewFetchingRecords, recordedStreams,
      } = this.props;
      let query = [];
      const { current_page: currentPage, last_page: pages } = recordedStreams
      if(currentPage < pages && !isNewFetchingRecords) {
         this.filter = { ...this.filter, page: currentPage + 1 };
         query = this.generateQuery();
         await recoredStreamsNextPage(query, this.state.isReorderMode);
      } else {
         return
      }
   }


   onClickGoTo = pageName => {
      const { goTo } = this.props
      switch (pageName) {
         case 'schedule':
            goTo(Router.route('LIVE_STREAM_SCHEDULE').getCompiledPath())
            break;
         case 'studio':
            goTo(Router.route('LIVE_STREAM_STUDIO').getCompiledPath())
            break;
         case 'create':
            goTo(Router.route('LIVE_STREAM_CREATE').getCompiledPath())
            break;

         default:
            break;
      }
   }

   // record streams functionality
   onFilterChange = (value, key) => {
      const { fetchRecordStreams, fetchCountsState, isInsideModal, updateFiltersInsideModal } = this.props
      let data = value
      if(!!Array.isArray(value)) {
         data = value.join(',')
      }
      if(!isInsideModal) {
         let urlKey = key
         if('casts' === key){
            urlKey = 'models'
         }
         let filtersData = {}
         filtersData = { ...this.filter, [urlKey]: data }
         this.generateUrlQuery(filtersData)
      } else {
         this.filter = { ...this.filter, count: 20, page: 1, [key]: data };
         let emptyFilters = true
         Object.keys(this.filter).forEach((key) => {
            if(!['conversation', 'count', 'hideScheduledContents', 'hideUnpublishedContents', 'insideModal', 'page', 'hiddenIds'].includes(key)) {
               if(!!this.filter[key]) emptyFilters = false
            }
         })

         this.setState({ emptyFilters })
      }
      let query = this.generateQuery()
      fetchRecordStreams(query, true, isInsideModal, this.state.isReorderMode)
      fetchCountsState(query);
      if(isInsideModal) updateFiltersInsideModal(this.filter)
   }

   onClearAllFilters = () => {
      const { isInsideModal, hideScheduledContents, updateFiltersInsideModal, fetchCountsState, fetchRecordStreams } = this.props
      this.filter = {
         page: 1,
         count: 20,
         hideScheduledContents,
         insideModal: isInsideModal ? 1 : 0,
      }

      QueryParams.removeAllQueryParam()
      this.setState({ emptyFilters: true })
      let query = this.generateQuery()

      fetchRecordStreams(query, true, null, this.state.isReorderMode)
      fetchCountsState(query)
      if(isInsideModal) updateFiltersInsideModal(this.filter)
   }

   generateQuery = () => {
      const query = [];
      Object.keys(this.filter).forEach((key) => {
         if(key){
            if(this.filter[key]) {
               'insideModal' !== key && key !== 'page' && key !== 'sortBy' && key !== 'hideScheduledContents' && key !== 'hideUnpublishedContents' ?
                  key === 'hiddenIds' ?
                     query.push(`hiddenIds[]=${ this.filter[key] }`)
                     :
                     query.push(`query[]=${ key }=${ encodeURIComponent(this.filter[key]) }`)
                  :
                  query.push(`${ key }=${ encodeURIComponent(this.filter[key]) }`);
            }
         }
      });

      return query;
   };

   generateUrlQuery = (filters, inited) => {
      if(filters && !isEmpty(filters)) {
         const urlParams = {};
         Object.keys(filters).forEach((key) => {
            if(key){
               if(key !== 'page') {
                  urlParams[key] = filters[key]
               }
               if(key === 'casts') {
                  urlParams.models = filters[key]
                  delete urlParams.casts
               }
               if(!filters[key]) {
                  delete urlParams[key]
               }
            }
         });
         QueryParams.defineFilters(urlParams)
      }
      let params = QueryParams.getFilters()

      if(params.models) {
         params.casts = params.models
         delete params.models
      }
      this.filter = { page: 1, ...params };
      if(!inited) {
         this.setState({
            emptyFilters: isEmpty(params),
         })
      }
   };

   onSendAccessRequest = () => {
      intercomMoreInfo(REQUEST_LIVESTREAM_ACCESS);
      const { fetchIndex } = this.props;
      fetchIndex('', true, null, this.state.isReorderMode)
   }

   openDeleteConfirmModal  = (id, bool) => {
      this.setState({
         openDeletModal: bool,
      })
      this.deleteVideoId = id;
   }

   handleCloseModalByUrl = () => {
      this.onTipModalClose()
   }

   onTipModalClose = () => {
      this.setState((...state) => {
         return {
            state,
            isTippersModalOpen: !this.state.isTippersModalOpen,
         }
      })
   }

   onClickSetId = (id) => {
      this.setState((...state) => {
         return {
            state,
            contentId: id,
         }
      })
      this.fetchContentTipsData(id);
   }

   fetchContentTipsData = (id) => {
      // eslint-disable-next-line no-unused-vars
      let data = getContentTipHistoryById(id, 'videos', '?video_type=livestream').then(res => {
         const { updateRecordStream } = this.props;
         const totalTips = [...res.data]?.reduce((prev, curr) => {
            prev += +curr.amount;
            return prev
         }, 0)
         updateRecordStream({ total_tip: totalTips, id })
         this.setState((...state) => {
            return {
               state,
               contentId: id,
               videoDataWithTips: res.data,
            }
         })
      }).catch((err) => {
         this.setState((...state) => {
            return {
               state,
               storyDataWithTips: [],
            }
         })
      })
   }

   cleanTipsState = () => {
      this.setState((...state) => {
         return {
            state,
            videoDataWithTips: null,
         }
      })


   }

   onSortEnd = async ({ newData, newIndex }, bool = false) => {
      // eslint-disable-next-line no-unused-vars
      const { reorderRecordedStreams, contentMetaInfo: { dont_show_content_reorder_message_livestream } } = this.props
      try {
         // if(!bool && !dont_show_content_reorder_message_livestream) {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: true,
         //       },
         //       reorderedData: { newData, newIndex },
         //    })
         // } else {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: false,
         //       },
         //       reorderedData: { newData: [], newIndex: null },
         //    })
         //    let replace_prev_id  = !!newData[newIndex - 1] ? newData[newIndex - 1].id : null
         //    let replaced_id = newData[newIndex].id
         //    let replace_next_id  = !!newData[newIndex + 1] ? newData[newIndex + 1].id : null
         //    if(!!replace_next_id  && !newData[newIndex + 1].is_published) {
         //       replace_next_id  = null
         //    }
         //    if(!!replace_prev_id  && !newData[newIndex - 1].is_published) {
         //       replace_prev_id  = null
         //    }
         //    const { data } = await changeContentOrders('videos', { replaced_id, replace_next_id, replace_prev_id, dont_show_message_again: dont_show_content_reorder_message_livestream })
         //    newData.forEach((item, index) => {
         //       if(item.id === replaced_id) {
         //          newData[index].publish_date = data
         //       }
         //    })
         //    reorderRecordedStreams(newData)
         //    toast.success('Content has been reordered')

         const isSortByAsc = this.filter.sortBy === 'date_added:asc'

         const orderedData = newData.map((item, index) => {
            return {
               id: item.id,
               order: !isSortByAsc ? newData.length - index : index + 1,
               name: item?.name,
            };
         })

         this.setState({
            reorderedData: { newData, newIndex },
         })

         await changeContentOrders('videos', { data: orderedData })

         reorderRecordedStreams(newData)
         toast.success('Content has been reordered')

      } catch (error) {
         console.log(error);
      }
   }

   onStatusFilter = (isReorderMode) => {
      const { goTo, updateLivestreamInitedState } = this.props
      let route = history.location.pathname === '/livestream' ? 'LIVE_STREAM_REORDER' : 'LIVE_STREAM'
      updateLivestreamInitedState(false)
      goTo(Router.route(`${ route }`).getCompiledPath())
   }

   onCloseWarningModal = () => {
      const { setWarningModal }  = this.props;
      setWarningModal({
         isOpen: false,
         description: null,
         ids: null,
         multiple_bundles: null,
         buttonText: null,
         title: null,
         buttonIconName: null,
      })
   }

   onActionWarningModal = () => {
      const { warningModal } = this.props;
      this.onCloseWarningModal();
      if('paid_for_unlock_or_download' !== warningModal.reason){
         if(warningModal?.multiple_bundles){
            window.open(`${ Router.route('STORE').getCompiledPath() }?q={"type":"content_bundle_item"}`);
         } else if(warningModal.ids?.[0]){
            window.open(Router.route('STORE_EDIT_BUNDLE').getCompiledPath({ id: generateUriSegment(warningModal.ids?.[0]) }));
         }
      }
   }
   render() {
      const {
         screenWidth,
         initData,
         isFetching,
         recordedStreams,
         resources,
         isFetchingRecordFilter,
         isEmptyByFilterRecord,
         isNewFetchingRecords,
         ivs,
         deleteRecordStream,
         deleteRecordButtonDisabled,
         isEmptyByRecord,
         isFetchingRecord,
         siteInfo: {
            site_url: siteUrl,
         },
         countesState,
         downloadFile,
         mediaDownloadButton,
         updateContentMetaInfo,
         contentMetaInfo,
         loginAs,
         pinRecordedStream,
         isInsideModal,
         selections,
         showNewStyles,
         onSelectThisVideo,
         contentType,
         bundleId,
         warningModal,
         siteInfo,
         checkAndUnlockDemoPublicSite,
         preventAutoSelect = false,
         showOnlyList,
      } = this.props;
      const {
         emptyFilters,
         openDeletModal,
         isTippersModalOpen,
         videoDataWithTips,
         contentId,
         isReorderMode,
         confirmModal,
         pinnedCount,
      } = this.state;

      if(isFetching){
         return (
            <PageLoader withLoader={ isInsideModal } customStyle='w-full h-full' />
         )
      }

      const isMobile = screenWidth < 1025;
      return (
         <>
            <LiveStreamList
               initData={ initData }
               isMobile={ isMobile }
               goTo={ this.onClickGoTo }
               recordedStreams={ recordedStreams }
               filters={ this.filter }
               resources={ resources }
               emptyFilters={ emptyFilters }
               onClearAllFilters={ this.onClearAllFilters }
               onFilterChange={ this.onFilterChange }
               isFetchingRecordFilter={ isFetchingRecordFilter }
               isFetchingRecord={ isFetchingRecord }
               isEmptyByFilterRecord={ isEmptyByFilterRecord }
               isEmptyByRecord={ isEmptyByRecord }
               isNewFetchingRecords={ isNewFetchingRecords }
               hasAccess={ !!ivs }
               onSendAccessRequest={ this.onSendAccessRequest }
               openDeleteConfirmModal={ (id) => this.openDeleteConfirmModal(id, true) }
               onTipModalClose={ this.onTipModalClose }
               onClickSetId={ this.fetchContentTipsData }
               siteUrl={ siteUrl }
               countesState={  isReorderMode ? { total: pinnedCount?.not_pinned_total } : countesState?.streams }
               downloadOriginalFile={ downloadFile }
               isDownloading={ mediaDownloadButton }
               screenWidth={ screenWidth }
               isReorderMode={ isReorderMode }
               setReorderMode={ () =>  this.onStatusFilter(isReorderMode) }
               onSortEnd={ this.onSortEnd }
               onClickPreview={ () => {
                  loginAs({ id: null, type: 'guest' }, siteUrl, 'recorded-streams')
               } }
               pinRecordedStream={ (id, bool) => pinRecordedStream(id, Boolean(bool)) }
               isInsideModal={ isInsideModal }
               selections={ selections }
               showNewStyles={ showNewStyles }
               onSelectThisVideo={ onSelectThisVideo }
               contentType={ contentType }
               bundleId={ bundleId }
               isDemoMode={ siteInfo?.site_status === 'demo_mode' }
               checkAndUnlockDemoPublicSite={ checkAndUnlockDemoPublicSite }
               preventAutoSelect={ preventAutoSelect }
               showOnlyList={ showOnlyList }
            />
            {
               openDeletModal && (
                  <Modal
                     contentPosition={ isMobile ? 'bottom' : 'center' }
                     onClose={ () => this.openDeleteConfirmModal(null, false) }
                     isCloseAction={ false }
                  >
                     <DeleteModal
                        type='video'
                        isDisabled={ deleteRecordButtonDisabled }
                        deleteCollection={ () => {
                           deleteRecordStream(this.deleteVideoId, null);
                           this.openDeleteConfirmModal(null, false);
                           if(recordedStreams.data && recordedStreams.data.length < 10){
                              this.nextPage();
                           }
                        } }
                        onClickCancel={ () => this.openDeleteConfirmModal(null, false) } />
                  </Modal>

               )
            }
            {
               contentId && isTippersModalOpen && (
                  <Modal
                     // fullScreenMode={ isMobileAndTablet() }
                     contentPosition='responsive'
                     onClose={ () => this.handleCloseModalByUrl() }
                     otherClassName='tipper sm:!rounded-xlg'
                  >
                     <TippersModal
                        onModalClose={ this.onTipModalClose }
                        content={ videoDataWithTips }
                        contentId={ contentId }
                        onTipsModalClose={ this.cleanTipsState }
                     />
                  </Modal>
               )
            }
            {
               confirmModal.isOpen &&
                  <ConfirmModal
                     title='Publication date change'
                     type='confirm'
                     icon='warning'
                     iconColor='warning'
                     description='Reordering has the effect of changing the publication date of content that is being reordered. Are you sure you want to reorder content?'
                     contentWidth='375px'
                     buttonText='Yes, I want to reorder content'
                     action={ () => this.onSortEnd({ newData: this.state.reorderedData.newData, newIndex: this.state.reorderedData.newIndex }, true) }
                     cancelButtonAction={ () => {
                        updateContentMetaInfo({
                           ...contentMetaInfo,
                           dont_show_content_reorder_message_livestream: false,
                        })
                        this.setState({
                           ...this.state,
                           confirmModal: {
                              isOpen: false,
                           },
                           reorderedData: {
                              newData: [],
                              newIndex: null,
                           },
                        })
                     } }
                     isPreventDeafault={ false }
                     isMobile={ screenWidth < 700 }
                  >
                     <div className='w-full mt-8 flex items-center justify-center'>
                        <CheckboxLabel
                           name='dont_show_message_again'
                           checked={ contentMetaInfo?.dont_show_content_reorder_message_livestream }
                           className='flex justify-center'
                           textColor='secondary'
                           label='Don’t show again'
                           onChange={ () => {
                              updateContentMetaInfo({
                                 ...contentMetaInfo,
                                 dont_show_content_reorder_message_livestream: !contentMetaInfo?.dont_show_content_reorder_message_livestream,
                              })
                           } }
                           padding='0'
                        />
                     </div>
                  </ConfirmModal >
            }
            {
               warningModal.isOpen &&
               <ConfirmModal
                  onCloseModal={ _ => {
                     if('paid_for_unlock_or_download' !== warningModal.reason){
                        this.onCloseWarningModal()
                     }
                  }
                  }
                  isCloseAction
                  type='confirm'
                  icon='warning'
                  withoutCloseButton
                  iconColor='warning'
                  title={ warningModal.title }
                  description={ warningModal?.description }
                  cancelText={ warningModal.cancelText }
                  buttonText={ warningModal.buttonText }
                  buttonIconName={ warningModal.buttonIconName }
                  secondaryButtonClassName={ warningModal.secondaryButtonClassName }
                  buttonClassName='mt-8'
                  action={ this.onActionWarningModal }
                  iconSize='2xl'
                  isMobile={ screenWidth < 701 }
               />
            }
         </>
      )
   }
}
const mapStateToProps = state => ({
   screenWidth: screenWidthSelector(state),
   siteInfo: siteInfoSelector(state),
   initData: initDataSelector(state),
   isFetching: isFetchingSelector(state),
   recordedStreams: recordedStreamsSelector(state),
   resources: resourcesSelector(state),
   isFetchingRecordFilter: isFetchingRecordFilterSelector(state),
   isEmptyByFilterRecord: isEmptyByFilterRecordSelector(state),
   isEmptyByRecord: isEmptyByRecordSelector(state),
   isNewFetchingRecords: isNewFetchingRecordsSelector(state),
   ivs: ivsSelector(state),
   deleteRecordButtonDisabled: deleteRecordButtonDisabledSelector(state),
   isFetchingRecord: isFetchingRecordSelector(state),
   countesState: countesStateSelector(state),
   mediaDownloadButton: mediaDownloadButtonSelector(state),
   contentMetaInfo: contentMetaInfoSelector(state),
   warningModal: warningModalSelector(state),
   isInited: isInitedSelector(state),
   filtersInsideModal: filtersInsideModalSelector(state),
})
const mapDispatchToProps = dispatch => ({
   goTo: location => {
      dispatch(push(location))
   },
   fetchIndex: (query, isFirstLoad, isInsideModal, isReorderMode, isCastMemberProfilePage) => dispatch(fetchIndexOperation(query, isFirstLoad, isInsideModal, isReorderMode, isCastMemberProfilePage)),
   fetchRecordStreams: (query, bool, isInsideModal, isReorderMode) => dispatch(fetchRecordStreamsOperation(query, bool, isInsideModal, isReorderMode)),
   recoredStreamsNextPage: (query, isReorderMode) => dispatch(recoredStreamsNextPageOperation(query, isReorderMode)),
   updateRecordStream: query => dispatch(createOrUpdateRecordStream(query)),
   deleteRecordStream: (id, callBack) => {
      dispatch(deleteRecordStreamOperation(id, 'list', callBack))
   },
   fetchCountsState: (query) => {
      dispatch(fetchMediaCountsStateOperation('streams', [...query, 'video_type=livestream']));
   },
   downloadFile: (id) => dispatch(downloadMediaOperation(id, 'videos', 'livestream')),
   reorderRecordedStreams: data => dispatch(reorderRecordedStreams(data)),
   updateContentMetaInfo: info => dispatch(contentMetaInfo(info)),
   loginAs: (data, url, pageUrl) => {
      dispatch(loginAsOperation(data, url, pageUrl));
   },
   pinRecordedStream: (id, bool) => dispatch(pinRecordedStreamOperations(id, bool)),
   setWarningModal: data => {
      dispatch(setWarningModal(data))
   },
   updateLivestreamInitedState: (inited) => dispatch(updateLivestreamInitedStateAction(inited)),
   updateFiltersInsideModal: (filters) => dispatch(updateFiltersInsideModalAction(filters)),
   checkAndUnlockDemoPublicSite: (callback) => dispatch(checkAndUnlockDemoPublicSiteOperation(callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamIndexContainer);
